module.exports = __webpack_public_path__ + "static/media/question.d4f7fad6.svg";